import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { ADMININTERMEDIARY_INIT_LOADING, ADMININTERMEDIARY_INIT_SUCCESS, ADMININTERMEDIARY_INIT_FAIL, ADMININTERMEDIARY_INTERGROUPLIST, ADMININTERMEDIARY_MENU_INIT_LOADING, ADMININTERMEDIARY_MENU_INIT_SUCCESS, ADMININTERMEDIARY_MENU_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'
const state = {
  init: 0,
  initErr: [],
  interGroupList: [],
  menu: {},
  intermediary: {
    init: 0,
    initErr: [],
    menu: {},
    inter: undefined,
    intermediaryName: undefined,
    dateOpened: undefined,
    dateClosed: undefined,
    interGroupCode: undefined,
    interGroupName: undefined,
    add1: undefined,
    add2: undefined,
    add3: undefined,
    add4: undefined,
    postalCode: undefined,
    suspended: undefined,
    strCreatedBy: undefined,
    strModifiedBy: undefined,
    interCommDiscFactorTabMenu: 0,
    interCommDiscFactorDisplayFactReviewTab: false,
    interCommDiscFactorDisplayRateTab: false,
    interCommDiscFactorProduct: undefined,
    interCommDiscFactorEffDate: undefined,
    interCommDiscFactors: {
      fact1: null,
      fact2: null,
      fact3: null,
      fact4: null,
      fact5: null,
      fact6: null
    },
    appIDList: [],
    factor1to3List: [],
    factor4to6List: [],
    interCommDiscFactorProductAppId: undefined,
    grpRefStmtDesc: undefined,
    grpRefAgeDesc: undefined,
    defNoPrtDrCr: undefined,
    defNoTaxInv: undefined,
    isDM: false,
    prtBuyerCreatedTaxInv: undefined
  }
}

const getters = {
}

const mutations = {
  [ADMININTERMEDIARY_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [ADMININTERMEDIARY_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [ADMININTERMEDIARY_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [ADMININTERMEDIARY_INTERGROUPLIST](state, data) {
    Vue.set(state, 'interGroupList', data)
  },
  [ADMININTERMEDIARY_MENU_INIT_LOADING](state) {
    resetProfile(state)
  },
  [ADMININTERMEDIARY_MENU_INIT_SUCCESS](state, data) {
    // Update menu
    state.intermediary.init = 1
    state.intermediary.initErr = []
    state.intermediary.menu = data.menu
    // data

    state.intermediary.interNoAe = data.data.interNoAe
    state.intermediary.inter = data.data.inter
    state.intermediary.interGroupCode = data.data.interGroupCode
    state.intermediary.interGroupName = data.data.interGroupName
    state.intermediary.interType = data.data.interType
    state.intermediary.titleName = data.data.titleName
    state.intermediary.intermediaryName = data.data.name
    // state.intermediary.name1 = data.data.name1
    // state.intermediary.name2 = data.data.name2
    // state.intermediary.name3 = data.data.name3
    // state.intermediary.name4 = data.data.name4
    state.intermediary.abbrevName = data.data.abbrevName
    state.intermediary.contact = data.data.contact
    state.intermediary.telNo1 = data.data.telNo1
    state.intermediary.telNo2 = data.data.telNo2
    state.intermediary.telNo3 = data.data.telNo3
    state.intermediary.telNo4 = data.data.telNo4
    state.intermediary.telNo5 = data.data.telNo5
    state.intermediary.add1 = data.data.add1
    state.intermediary.add2 = data.data.add2
    state.intermediary.add3 = data.data.add3
    state.intermediary.add4 = data.data.add4
    state.intermediary.add1UW = data.data.add1
    state.intermediary.add2UW = data.data.add2
    state.intermediary.add3UW = data.data.add3
    state.intermediary.add4UW = data.data.add4
    state.intermediary.postalCode = data.data.postalCode
    state.intermediary.addrState = data.data.addrState
    state.intermediary.addrCtry = data.data.addrCtry
    state.intermediary.email = data.data.email
    state.intermediary.web = data.data.web
    state.intermediary.dateOpened = data.data.dateOpened
    state.intermediary.dateClosed = data.data.dateClosed
    state.intermediary.commType = data.data.commType
    state.intermediary.branch = data.data.branch
    state.intermediary.cty = data.data.cty
    state.intermediary.ctyUW = data.data.cty
    state.intermediary.regAgt = data.data.regAgt
    state.intermediary.gstRegNo = data.data.gstRegNo
    state.intermediary.gstRegDate = data.data.gstRegDate
    state.intermediary.gstKeyRegAgt = data.data.gstKeyRegAgt
    state.intermediary.crPer = data.data.crPer
    state.intermediary.crLim = data.data.crLim
    state.intermediary.crLimCurr = data.data.crLimCurr
    state.intermediary.perDebtTran = data.data.perDebtTran
    state.intermediary.blackList = data.data.blackList
    state.intermediary.inactive = data.data.inactive
    state.intermediary.suspended = data.data.suspended
    state.intermediary.insdDisc = data.data.insdDisc
    state.intermediary.execIC = data.data.execIc
    state.intermediary.schemeMand = data.data.schemeMand
    state.intermediary.stmtType = data.data.stmtType
    // state.intermediary.grpRefStmt = data.data.grpRefStmt
    // state.intermediary.grpRefAge = data.data.grpRefAge
    state.intermediary.grpRefStmt = data.grpRefStmtDesc
    state.intermediary.grpRefAge = data.grpRefAgeDesc
    state.intermediary.defNoPrtDrCr = data.data.defNoPrtDrCr
    state.intermediary.defNoTaxInv = data.data.defNoTaxInv
    state.intermediary.isDM = data.data.isDM
    state.intermediary.prtBuyerCreatedTaxInv = data.data.prtBuyerCreatedTaxInv
    state.intermediary.createdBy = data.data.createdBy
    state.intermediary.createdDate = data.data.createdDate
    state.intermediary.modifiedBy = data.data.modifiedBy
    state.intermediary.modifiedDate = data.data.modifiedDate

    state.intermediary.strCreatedBy = data.strCreatedBy
    state.intermediary.strModifiedBy = data.strModifiedBy

    // state.intermediary.interType = data.data.interType
    // state.intermediary.defNoTaxInv = data.data.defNoTaxInv
    // state.intermediary.glAn1 = data.data.glAn1
    // state.intermediary.glAn2 = data.data.glAn2
    // state.intermediary.grpRefStats = data.data.grpRefStats

    state.intermediary.appIDList = data.appIDList
  },
  [ADMININTERMEDIARY_MENU_INIT_FAIL](state, error) {
    state.intermediary.init = 2
    state.intermediary.initErr = error
    state.intermediary.menu = {}

    state.intermediary.appIDList = []

    state.intermediary.strCreatedBy = ''
    state.intermediary.strModifiedBy = ''
  }
}

const actions = {
  async interManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.interManagement
    commit(ADMININTERMEDIARY_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(ADMININTERMEDIARY_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMININTERMEDIARY_INIT_FAIL, extractMessages(error))
    }
  },
  async interMenuInit({ commit, state }, inter) {
    commit(ADMININTERMEDIARY_MENU_INIT_LOADING)
    try {
      const apiURI = state.menu.interGet
      const expand = {
        inter: inter
      }
      const result = await http.get(expandURI(apiURI, expand))
      const menu = extractMenu(result.data._links)
      const commitResult = {
        data: result.data.data.inter,
        appIDList: result.data.data.appIDList,
        strCreatedBy: result.data.data.strCreatedBy,
        strModifiedBy: result.data.data.strModifiedBy,
        grpRefStmtDesc: result.data.data.grpRefStmtDesc,
        grpRefAgeDesc: result.data.data.grpRefAgeDesc,
        menu: menu
      }
      commit(ADMININTERMEDIARY_MENU_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMININTERMEDIARY_MENU_INIT_FAIL, extractMessages(error))
    }
  }
}
const resetProfile = (state) => {
  state.intermediary.init = 0
  state.intermediary.initErr = []
  // state.intermediary.intermediaryName = undefined
  state.intermediary.dateOpened = undefined
  state.intermediary.dateClosed = undefined
  // state.intermediary.interGroupCode = undefined
  // state.intermediary.interGroupName = undefined
  // state.intermediary.add1 = undefined
  // state.intermediary.add2 = undefined
  // state.intermediary.add3 = undefined
  // state.intermediary.add4 = undefined
  // state.intermediary.postalCode = undefined
  state.intermediary.suspended = undefined
  state.intermediary.interProductId = undefined
}

export default {
  state,
  getters,
  mutations,
  actions
}
